import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {field} from "../../stem-core/state/StoreField";
import {apiClient} from "../connection/BlinkApiClient";
import {EditableObjectStatus} from "./misc/GenericEnums";
import {BUILD_VERSION} from "../../blink-sdk/Constants";
import {StemDate} from "../../stem-core/time/Time";
import {Currency} from "../../stem-core/localization/CurrencyStore";
import {LegalEntity} from "./LegalEntityStore";


@globalStore
export class Merchant extends BaseStore("Merchant") {
    @field("Currency") currency: Currency;
    @field(String) name: string;
    @field(String) alias: string;
    @field(Date) createdAt: StemDate;
    @field(String) url: string;
    @field(String) wideLogoUrl: string;

    @field(Boolean) isFake: boolean;
    @field(Boolean) isNonprofit: boolean;

    @field(Boolean) autoPay: boolean;
    @field(Boolean) allowEmailing: boolean;
    @field(Boolean) allowPurchases: boolean;
    @field(Boolean) allowSubscriptions: boolean;
    @field(Boolean) allowDonations: boolean;
    @field(Boolean) allowUnverifiedEmailUsers: boolean;

    @field("LegalEntity") legalEntity: LegalEntity;
    @field(Number) legalEntityId: number;

    @field(EditableObjectStatus) sdkStatus: EditableObjectStatus;

    @field(Object) userMetadataFields: any;

    getUrl(): string {
        if (BUILD_VERSION) {
            return this.url;
        }
        return `http://localhost:8077/?clientId=${this.alias}`;
    }

    getName(): string {
        return this.name;
    }

    getCurrency(): Currency {
        return this.currency;
    }

    isAutopayCompatible(): boolean {
        return this.autoPay === true;
    }

    toString(): string {
        return this.name;
    }

    hasPurchasesEnabled(): boolean {
        return !!this.allowPurchases;
    }

    hasSubscriptionsEnabled(): boolean {
        return !!this.allowSubscriptions;
    }

    hasSubscriptionDiscountCodeEnabled(): boolean {
        return !!this.hasSubscriptionDiscountCode;
    }

    hasDonationsEnabled(): boolean {
        return !!this.allowDonations;
    }

    static getAutopayCompatibleMerchants(): Merchant[] {
        return this.all().filter(merchant => merchant.isAutopayCompatible());
    }

    static getByIdOrAlias(key: string | number): Merchant | undefined {
        const entry = this.get(key);
        if (entry) {
            return entry;
        }
        return this.all().find(merchant => merchant.alias === key);
    }
}

export async function apiMerchantEditSettings(request: any): Promise<any> {
    return apiClient.post("/merchant/edit_global_settings", request);
}